/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://mhhvykiodi.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "ForceLogoutAndRefresh",
            "endpoint": "https://uodnmomqlc.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "ManageNotificationPreferences",
            "endpoint": "https://0mnzr3zs1b.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "ProcessPerformanceData",
            "endpoint": "https://rj8788spg7.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "ScheduleNotifications",
            "endpoint": "https://aor0e1j7ob.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "SendInternalMessage",
            "endpoint": "https://8ue7ego9zd.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "Signup",
            "endpoint": "https://e728zcjik3.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "bandwidth",
            "endpoint": "https://fxykc01i62.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "counseling",
            "endpoint": "https://g7bpi8xc1b.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "csvDataExport",
            "endpoint": "https://2ucg35z5a2.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "documentSignService",
            "endpoint": "https://od26drmeoe.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "downloadFiles",
            "endpoint": "https://utb1tr9no2.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "handleTelnyxResponse",
            "endpoint": "https://ufuolr6ip5.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "heraPublicApi",
            "endpoint": "https://w3wo59jw7b.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "intercomUpdateCompanies",
            "endpoint": "https://n0qv4ilxae.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "invoice",
            "endpoint": "https://l9zybw8kj6.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "messages",
            "endpoint": "https://pm2li4epqb.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "rds",
            "endpoint": "https://dndlx5qahf.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "s3downloadlink",
            "endpoint": "https://wqy8639jkj.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "sendMessage",
            "endpoint": "https://2h7x9yi967.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "sendMessages",
            "endpoint": "https://cj1l4tta74.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "sendPendingCoachingMessage",
            "endpoint": "https://99h5yrew8k.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "sesSuppression",
            "endpoint": "https://6rq6w7qpmj.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "stripeCharge",
            "endpoint": "https://lbhf52h04a.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "stripeSetup",
            "endpoint": "https://a6k6jnncfl.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "tenant",
            "endpoint": "https://7503tsrm6h.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "trackAuditLog",
            "endpoint": "https://5viv8vb3y0.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "vehicle",
            "endpoint": "https://17scqoidfi.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        },
        {
            "name": "zoho",
            "endpoint": "https://vzkacb36j7.execute-api.us-east-2.amazonaws.com/rqa",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://6kpfbxvxtze2zpe2jntbmxu6fq.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-2ldwtjmhwrefzmd4p2zzh22pq4",
    "aws_cognito_identity_pool_id": "us-east-2:8a62a5cc-560e-4896-8860-2217f23aecef",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_OKaLVmspE",
    "aws_user_pools_web_client_id": "1ldiorsrutkbqasdhi9a556ds0",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "hera2009fb1ba5504c8da9ba5f1fe34db738c5486-rqa",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
